import React from 'react'
import { useTranslation } from 'react-i18next'

import AdPlacementsSelect from './AdPlacementsSelect'
import FieldLabelWrapper from '../../../../../../../../../../../../features/components/Form/FieldLabelWrapper'
import SubAllocationTableHeader from '../SubAllocationTableHeader'
import ErrorMessage from '../../../../../../../../../../../../components/Form/ErrorMessage'

import { AD_PLACEMENTS, IS_SUB_ALLOCATION } from '../../../../fields'

const SelectedAdPlacementsTable = ({ formik, allocationPriceLabel }) => {
  const { t } = useTranslation()
  const { values, errors, touched } = formik

  const placementsError = errors[AD_PLACEMENTS]
  const placementsTouched = touched[AD_PLACEMENTS]
  const showPlacementsError = placementsError && typeof placementsError === 'string' && placementsTouched

  const hasSelectedItems = values[AD_PLACEMENTS].length > 0

  return (
    <FieldLabelWrapper label={hasSelectedItems ? 'Selected placements' : ''}>
      {hasSelectedItems && values[IS_SUB_ALLOCATION] && (
        <SubAllocationTableHeader title={t('Placement')} allocationPriceLabel={allocationPriceLabel} />
      )}
      <AdPlacementsSelect formik={formik} />
      {showPlacementsError && <ErrorMessage error={placementsError} />}
    </FieldLabelWrapper>
  )
}

export default SelectedAdPlacementsTable
